export const ATOM_DEBUG_KEY = 'isDebugMode';
export const ATOM_DARK_MODE_KEY = 'isDarkMode';
export const ATOM_PRODUCTION_SCHEDULE_REFETCH_KEY = 'isSchedulerProductionRefetchNeeded';
export const ATOM_RESERVATION_SCHEDULE_REFETCH_KEY = 'isSchedulerReservationRefetchNeeded';
